import { useMetrics } from '@cognite/metrics';
import { LOCIZE_NAMESPACES, useTranslation } from '@infield/features/i18n';
import { METRICS_NAMESPACES } from '@infield/features/metrics';
import type { FC } from 'react';

import { useTemplateConfirmationDeps } from './template-created-confirmation-page-context';
import { TemplateCreatedConfirmationPageUI } from './template-created-confirmation-page-ui';

export const TemplateCreatedConfirmationPage: FC = () => {
  const { navigate, checklistExternalId } = useTemplateConfirmationDeps();

  const metrics = useMetrics(METRICS_NAMESPACES.templatesMobile);
  const { t } = useTranslation(LOCIZE_NAMESPACES.template);

  const navigateToTemplates = () => {
    metrics.track('Navigated to templates');
    navigate('/templates');
  };

  const navigateToChecklist = () => {
    metrics.track('Navigated to checklist');
    navigate({
      pathname: `/activity/${checklistExternalId}/checklist`,
    });
  };

  return (
    <TemplateCreatedConfirmationPageUI
      onBack={navigateToTemplates}
      onWorkOnChecklist={navigateToChecklist}
      translationFunction={t}
    />
  );
};
